<template>
	<div class="app-wrapper" >	
		<sidebar  class="sidebar-container" :isCollapse="isCollapse" textcolor="#fff" :device="device" :menuLogo="true"></sidebar>
		<div class="main-container">			
			<app-main></app-main>
		</div>
	</div>
</template>

<script>
	import AppMain from '@/views/layout/components/AppMain' //页面布局的右侧区域
	import sidebar from '@/views/layout/components/sidebar' //页面布局的左侧菜单

	import publicMinxin from "@/views/layout/components/public.mixin.js";
	export default {
		mixins: [publicMinxin],
	
		name: 'layout',
		components: {
			sidebar,
			AppMain
		},
		data() {
			return {
				collapse: true,
				drawer: true,
				device: 'desktop',
				isCollapse:false
		
				
			}
		},
		methods: {
			handleCollapse() {
				this.collapse = !this.collapse
				this.drawer = !this.drawer
				this.isCollapse= !this.isCollapse
			},
		},
		mounted() {
		}
	}
</script>

<style lang="scss" >
	.app-wrapper {
		position: relative;
		height: 100%;
		width: 100%;
	}
	.sidebar-container{
		
	}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue